export const sources={};export const img={src:"__VITE_ASSET___ewJD0zO9$SsiDvawfmAUw__",w:640,h:640};export default{sources:sources,img:img};